import { Deserializable } from '../../../models/protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../../../models/enum/shared/governing-jurisdiction-type-id';

export interface SpousalVariableBenefitActiveSpouse {
  spouseId: number;
  name: string;
  linkedMemberId: number | null;
}

export interface SpousalVariableBenefitSpecifiedBeneficiary {
  name: string;
  memberId: number | null;
}

export interface SpousalVariableBenefitMinimumAge {
  name: string;
  dateOfBirth: string;
  isSpouse: boolean;
}

export interface SpousalVariableBenefitSourceAccount {
  accountId: number;
  idPrefix: string;
  governingJurisdictionId: GoverningJurisdictionTypeId | null;
  governingJurisdiction: string | null;
  createdDate: string;
  specifiedBeneficiary: SpousalVariableBenefitSpecifiedBeneficiary | null;
  minimumAge: SpousalVariableBenefitMinimumAge;
  effectiveYear: number;
  minimumAnnualWithdrawalAmount: number;
  maximumAnnualWithdrawalAmount: number;
  struckOnBalance: number | null;
  struckOnDate: string | null;
  yearToDatePaymentAmount: number;
}

export class IpSpousalVariableBenefitSourceAccounts implements Deserializable {
  public memberId!: number;
  public activeSpouse!: SpousalVariableBenefitActiveSpouse | null;
  public accounts: SpousalVariableBenefitSourceAccount[] = [];

  public onDeserialize(): void {
    this.accounts = this.accounts ?? [];
  }
}
